import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import { mapActions } from 'vuex'
import { alertEventService } from '../../../../../services/alertEvent.service';

export default {
    name: 'AlertEventDialogUsersTabComponent',
    components: {
        TreeSelectorComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // loading del selector de cosas
        loadingUsers: false,
        // selector de cosas
        users: [],
        userList: [],
        headers: ['Nombre de Usuario', "Email", 'Portal Agro'],
        filter: '',
        emails: '',
        emailsRulesValid: true,
        emailsRules: [true]
    }),
    computed: {
        usersFiltered() {
            const usersId = alertEventService.getUsersIdNotificationsList(this.userList, this.emails);
            this.updateSelected(usersId);
            return this.userList.filter(userData => userData.username.toLowerCase().includes(this.filter.toLowerCase()));
        },
        allChecked() {
            const result = this.usersFiltered.length > 0;
            for (const userData of this.usersFiltered) {
                if (!userData.pushChecked || !userData.emailChecked) {
                    return false;
                }
            }
            return result;
        }
    },
    created() {
    },
    mounted() {
        this.userList.cleanAndUpdate(this.model.usersData.map(({ _id, username, firstName, lastName, email }) => { return { _id, username, firstName, lastName, email, pushChecked: false, emailChecked: false } }))
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        selectorMapper(node) {
            return {
                id: node._id,
                label: node.username + ' - ' + node.firstName + ' ' + node.lastName
            }
        },
        updateSelected(users) {
            this.model.userIds.cleanAndUpdate(users);
            this.model.userIds.length > 0 ? this.isValidForm = true : this.isValidForm = false;
        },
        toggleCheckByUser(event, userData) {
            userData.pushChecked = event.target.checked;
            userData.emailChecked = event.target.checked;
        },
        toggleAllCheck(event) {
            this.usersFiltered.forEach((userData) => {
                this.toggleCheckByUser(event, userData);
            });
        },
        emailsEdited(event) {
            const isValid = alertEventService.validateEmailList(event.target.value);
            this.emailsRules = [isValid];
            this.emailsRulesValid = isValid;
            const usersId = alertEventService.getUsersIdNotificationsList(this.userList, event.target.value);
            this.updateSelected(usersId);
            this.emails = event.target.value;
        }
    },
    watch: {
        'model.userIds': {
            deep: true,
            immediate: true,
            handler: function (newUsers) {
                this.$emit('elementSelected', newUsers)
            }
        },
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (this.model.userIds.length > 0 && this.emailsRulesValid) {
                    this.isValidForm = true
                } else {
                    this.isValidForm = false
                }
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.alertEventDialogUserTabForm) {
                this.$refs.alertEventDialogUserTabForm.resetValidation()
            }
        }
    }
}
